// extracted by mini-css-extract-plugin
export default {"cls1":"PingAnswerStyles-cls1___277825b22dcfd1e1c19","cls2":"PingAnswerStyles-cls2__eba91ac7f15533ccdd30 PingAnswerStyles-cls1___277825b22dcfd1e1c19"};